import { http } from "../client";
import { getScheduleDays, getScheduleTime } from "./get-all";
export var getTimetableDetail = function (id) {
    return http.api
        .get("timetables/" + id)
        .then(function (response) { return response.data.data; })
        .then(function (_a) {
        var id = _a.id, title = _a.title, client_id = _a.client_id, used_by = _a.used_by, entries = _a.entries;
        return ({
            id: id,
            title: title,
            usedBy: used_by,
            userId: client_id,
            scheduleDays: getScheduleDays(entries),
            scheduleTime: getScheduleTime(entries),
            programs: entries.map(function (_a) {
                var id = _a.id, title = _a.title, client_id = _a.client_id, days_enabled = _a.days_enabled, is_enabled = _a.is_enabled, timetable_program_id = _a.timetable_program_id, playlist_id = _a.playlist_id, n_tracks = _a.n_tracks, track_id = _a.track_id, track_repeat_interval_minutes = _a.track_repeat_interval_minutes, play_order = _a.play_order, time_end = _a.time_end, time_start = _a.time_start, timetable_id = _a.timetable_id, strict_order = _a.strict_order, interrupt_playing = _a.interrupt_playing;
                return ({
                    id: id,
                    title: title,
                    userId: client_id,
                    daysEnabled: days_enabled,
                    isEnabled: is_enabled === 1,
                    rulesetId: timetable_program_id !== null && timetable_program_id !== void 0 ? timetable_program_id : -1,
                    playlistId: playlist_id,
                    nTracks: n_tracks,
                    trackId: track_id,
                    trackRepeatIntervalMinutes: track_repeat_interval_minutes,
                    playOrder: play_order !== null && play_order !== void 0 ? play_order : "forward",
                    timeEnd: time_end,
                    timeStart: time_start,
                    timetableId: timetable_id,
                    strictOrder: Boolean(strict_order),
                    interruptPlaying: Boolean(interrupt_playing),
                });
            }),
        });
    });
};
